<template>
  <v-container>
    <v-row>
      <v-col>
        <p>Botão</p>
        <v-row class="my-2">
          <base-btn>teste</base-btn>
          <base-btn disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn size="small">teste</base-btn>
          <base-btn size="small" disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row>
          <base-btn size="xsmall">teste</base-btn>
          <base-btn size="xsmall" disabled class="ml-1">teste</base-btn>
        </v-row>
      </v-col>

      <v-col>
        <p>Botão secondary</p>
        <v-row class="my-2">
          <base-btn type="secondary">teste</base-btn>
          <base-btn type="secondary" disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn type="secondary" size="small">teste</base-btn>
          <base-btn size="small" type="secondary" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
        <v-row>
          <base-btn type="secondary" size="xsmall">teste</base-btn>
          <base-btn size="xsmall" type="secondary" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
      </v-col>

      <v-col>
        <p>Botão tertiary</p>

        <v-row class="my-2">
          <base-btn type="tertiary">teste</base-btn>
          <base-btn type="tertiary" disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn type="tertiary" size="small">teste</base-btn>
          <base-btn size="small" type="tertiary" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
        <v-row>
          <base-btn type="tertiary" size="xsmall">teste</base-btn>
          <base-btn size="xsmall" type="tertiary" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
      </v-col>

      <v-col>
        <p>Botão danger</p>
        <v-row class="my-2">
          <base-btn type="danger">teste</base-btn>
          <base-btn type="danger" disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn type="danger" size="small">teste</base-btn>
          <base-btn size="small" type="danger" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
        <v-row>
          <base-btn type="danger" size="xsmall">teste</base-btn>
          <base-btn size="xsmall" type="danger" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
      </v-col>

      <v-col>
        <p>Botão neutral</p>
        <v-row class="my-2">
          <base-btn type="neutral">teste</base-btn>
          <base-btn type="neutral" disabled class="ml-1">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn type="neutral" size="small">teste</base-btn>
          <base-btn size="small" type="neutral" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
        <v-row>
          <base-btn type="neutral" size="xsmall">teste</base-btn>
          <base-btn size="xsmall" type="neutral" disabled class="ml-1"
            >teste</base-btn
          >
        </v-row>
      </v-col>

      <v-col>
        <p>Botão trial</p>
        <v-row class="my-2">
          <base-btn type="trial">teste</base-btn>
        </v-row>
        <v-row class="mb-2">
          <base-btn type="trial" size="small">teste</base-btn>
        </v-row>
        <v-row>
          <base-btn type="trial" size="xsmall">teste</base-btn>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col>
        <p>Checkbox</p>
        <v-row class="my-2">
          <v-checkbox
            v-model="checkboxMarked"
            label="normal checkbox"
          ></v-checkbox>
        </v-row>
        <v-row class="mb-2">
          <v-checkbox
            :indeterminate="true"
            label="indeterminate checkbox"
          ></v-checkbox>
        </v-row>
        <v-row>
          <v-checkbox
            v-model="checkboxMarkedDisabled"
            label="disabled checkbox"
            disabled
          ></v-checkbox>
        </v-row>
        <v-row>
          <v-checkbox label="disabled checkbox" disabled></v-checkbox>
        </v-row>
      </v-col>

      <v-col>
        <p>Radio Button</p>
        <v-row class="my-2">
          <v-radio-group v-model="radioGroup">
            <v-radio
              v-for="n in 3"
              :key="n"
              :label="`Radio ${n}`"
              :value="n"
            ></v-radio>
          </v-radio-group>
        </v-row>

        <v-row>
          <v-radio-group v-model="radioActive">
            <v-radio label="disabled" disabled></v-radio>
            <v-radio label="disabled true" disabled value="active"></v-radio>
          </v-radio-group>
        </v-row>
      </v-col>

      <v-col>
        <p>Toggle / Switch</p>
        <v-row class="my-2">
          <v-switch label="Switch"> </v-switch>
        </v-row>
        <v-row class="mb-2">
          <v-switch label="Switch disabled" disabled> </v-switch>
        </v-row>
        <v-row class="mb-2">
          <v-switch label="Switch disabled true" disabled v-model="trueSwitch">
          </v-switch>
        </v-row>
      </v-col>

      <v-col>
        <p>Chip</p>
        <v-row class="my-2">
          <v-chip> teste </v-chip>
        </v-row>
        <v-row class="mb-2"> <v-chip size="small"> teste </v-chip></v-row>
        <v-row class="mb-2"> <v-chip disabled> teste </v-chip> </v-row>
        <v-row class="mb-2">
          <v-chip disabled size="small"> teste </v-chip></v-row
        >
        <span>Chip Group {{ selectedItem }}</span>
        <v-chip-group v-model="selectedItem">
          <v-chip size="small"> teste1 </v-chip>
          <v-chip size="small"> teste2 </v-chip>
          <v-chip size="small"> teste3 </v-chip>
          <v-chip size="small"> teste4 </v-chip>
        </v-chip-group>
      </v-col>

      <v-col>
        <p>Slider</p>
        <v-row class="my-2">
          <v-slider max="100" min="0">
            <template #prepend>
              <div class="minmaxcontainer">
                <p class="minmax">0</p>
                <v-icon size="16" class="ml-2">mdi-volume-medium</v-icon>
              </div>
            </template>
            <template #append>
              <div class="minmaxcontainer">
                <v-icon size="16" class="mr-2">mdi-volume-high</v-icon>
                <p class="minmax">100</p>
              </div></template
            >
          </v-slider>
        </v-row>
        <v-row class="mb-2">
          <v-slider disabled value="30">
            <template #prepend>
              <div class="minmaxcontainer disabled">
                <p class="minmax">0</p>
                <v-icon size="16" class="ml-2">mdi-volume-medium</v-icon>
              </div>
            </template>
            <template #append>
              <div class="minmaxcontainer disabled">
                <v-icon size="16" class="mr-2">mdi-volume-high</v-icon>
                <p class="minmax">100</p>
              </div></template
            ></v-slider
          ></v-row
        >
      </v-col>
    </v-row>

    <v-row class="mt-10">
      <v-col>
        <p>Link</p>
        <v-row class="my-2">
          <a href="sfasf" type="primary" disabled>Primary Disabled</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="primary">Primary</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="primary" size="small">Primary Small</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="primary" size="xsmall">Primary xSmall</a>
        </v-row>

        <v-row class="my-2">
          <a href="sfasf" type="secondary" disabled>Secondary Disabled</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="secondary">Secondary</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="secondary" size="small">Secondary Small</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="secondary" size="xsmall">Secondary xSmall</a>
        </v-row>

        <v-row class="my-2">
          <a href="sfasf" type="tertiary" disabled>Tertiary Disabled</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="tertiary">Tertiary</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="tertiary" size="small">Tertiary Small</a>
        </v-row>
        <v-row class="my-2">
          <a href="sfasf" type="tertiary" size="xsmall">Tertiary xSmall</a>
        </v-row>
      </v-col>

      <v-col>
        <p>Tooltip</p>
        <v-row class="my-2">
          <v-tooltip top v-model="testTooltip">
            <template v-slot:activator="{ on, attrs }">
              <span v-on="on" v-bind="attrs">HOVER HEREE</span>
            </template>
            <span
              >Lorem ipsum dolor,&nbsp;
              <base-btn type="neutral" size="xsmall">
                Saiba mais
                <v-icon size="16" class="ml-1">mdi-open-in-new</v-icon>
              </base-btn>
            </span>
          </v-tooltip>
        </v-row>
      </v-col>

      <v-col>
        <p>tag</p>
        <v-row class="my-2">
          <v-tag type="error">Error</v-tag>
          <v-tag type="error" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="success">Error</v-tag>
          <v-tag type="success" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="alert">Error</v-tag>
          <v-tag type="alert" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="default">Error</v-tag>
          <v-tag type="default" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="neutral">Error</v-tag>
          <v-tag type="neutral" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="disabled">Error</v-tag>
          <v-tag type="disabled" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
        <v-row class="my-2">
          <v-tag type="trial">Error</v-tag>
          <v-tag type="trial" size="xsmall" class="ml-1">Error</v-tag>
        </v-row>
      </v-col>

      <v-col class="pr-8">
        <p>input</p>

        <v-row class="my-2 mt-5">
          <v-input
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="inputText"
            counter="40"
            :messages="['teste']"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            label="error"
            placeholder="placeholder"
            error
            v-model="inputText"
            counter="40"
            :messages="['teste']"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            v-model="inputText"
            label="disabled"
            placeholder="placeholder"
            disabled
            counter="40"
            :messages="['teste']"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            label="readonly"
            placeholder="placeholder"
            readonly
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            v-model="inputText"
            label="readonly no placeholder"
            readonly
          ></v-input>
        </v-row>

        <v-row class="my-2 mt-5">
          <v-input
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="inputText"
            size="small"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            label="error"
            placeholder="placeholder"
            error
            v-model="inputText"
            size="small"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            v-model="inputText"
            label="disabled"
            placeholder="placeholder"
            disabled
            size="small"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            label="readonly"
            placeholder="placeholder"
            readonly
            size="small"
          ></v-input>
        </v-row>

        <v-row class="my-2">
          <v-input
            v-model="inputText"
            label="readonly no placeholder"
            size="small"
            readonly
          ></v-input>
        </v-row>
      </v-col>

      <v-col>
        <p>textarea</p>

        <v-row class="my-2 mt-5">
          <v-textarea
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="textAreaText"
            counter="5000"
            :hide-details="hideDetails"
          ></v-textarea>
          <v-btn @click="testHideDetails">testHideDetails</v-btn>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            label="error"
            placeholder="placeholder"
            error
            v-model="textAreaText"
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            v-model="textAreaText"
            label="disabled"
            placeholder="placeholder"
            disabled
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            label="readonly"
            placeholder="placeholder"
            readonly
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            v-model="textAreaText"
            label="readonly no placeholder"
            readonly
          ></v-textarea>
        </v-row>

        <v-row class="my-2 mt-5">
          <v-textarea
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="textAreaText"
            size="small"
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            label="error"
            placeholder="placeholder"
            error
            v-model="textAreaText"
            size="small"
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            v-model="textAreaText"
            label="disabled"
            placeholder="placeholder"
            disabled
            size="small"
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            label="readonly"
            placeholder="placeholder"
            readonly
            size="small"
          ></v-textarea>
        </v-row>

        <v-row class="my-2">
          <v-textarea
            v-model="textAreaText"
            label="readonly no placeholder"
            readonly
            size="small"
          ></v-textarea>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="mt-2">
      <v-col class="mr-10">
        <p>input-select</p>

        <v-row class="my-2 mt-5">
          <v-input-select
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="inputPhoneNum"
            :options="[
              {
                value: 55,
                label: '+55',
                img: 'brazil',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            label="error"
            placeholder="placeholder"
            error
            v-model="inputPhoneNum"
            :options="[
              {
                value: 55,
                label: '+55',
                img: 'brazil',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            v-model="inputPhoneNum"
            label="disabled"
            placeholder="placeholder"
            disabled
            :options="[
              {
                value: 55,
                label: '+55',
                img: 'brazil',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            label="readonly"
            placeholder="placeholder"
            readonly
            :options="[
              {
                value: 55,
                label: '+55',
                img: 'brazil',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            v-model="inputPhoneNum"
            label="readonly no placeholder"
            readonly
            :options="[
              {
                value: 55,
                label: '+55',
                img: 'brazil',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2 mt-5">
          <v-input-select
            size="small"
            label="TYPE HERE"
            placeholder="placeholder"
            v-model="inputPhoneNum"
            :options="[
              {
                value: 55,
                label: '+55',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            label="error"
            size="small"
            placeholder="placeholder"
            error
            v-model="inputPhoneNum"
            :options="[
              {
                value: 55,
                label: '+55',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            size="small"
            v-model="inputPhoneNum"
            label="disabled"
            placeholder="placeholder"
            disabled
            :options="[
              {
                value: 55,
                label: '+55',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            label="readonly"
            size="small"
            placeholder="placeholder"
            readonly
            :options="[
              {
                value: 55,
                label: '+55',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>

        <v-row class="my-2">
          <v-input-select
            v-model="inputPhoneNum"
            size="small"
            label="readonly no placeholder"
            readonly
            :options="[
              {
                value: 55,
                label: '+55',
              },
              {
                value: 12,
                label: '+12',
              },
              {
                value: 21,
                label: '+21',
              },
              {
                value: 32,
                label: '+32',
              },
              {
                value: 44,
                label: '+44',
              },
            ]"
          ></v-input-select>
        </v-row>
      </v-col>

      <v-col>
        <p>select</p>

        <v-row class="my-2 mt-5">
          <v-select
            label="TYPE HERE"
            placeholder="placeholder"
            :items="['clar', 'ti', 'io', 'ivov']"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            label="error"
            placeholder="placeholder"
            error
            :items="['clar', 'ti', 'io', 'ivov']"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            :items="['clar', 'ti', 'io', 'ivov']"
            label="disabled"
            placeholder="placeholder"
            disabled
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            label="readonly"
            placeholder="placeholder"
            readonly
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            :items="['clar', 'ti', 'io', 'ivov']"
            label="readonly no placeholder"
            readonly
          ></v-select>
        </v-row>

        <v-row class="my-2 mt-5">
          <v-select
            label="TYPE HERE"
            placeholder="placeholder"
            :items="['clar', 'ti', 'io', 'ivov']"
            size="small"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            label="error"
            placeholder="placeholder"
            error
            :items="['clar', 'ti', 'io', 'ivov']"
            size="small"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            :items="['clar', 'ti', 'io', 'ivov']"
            label="disabled"
            placeholder="placeholder"
            disabled
            size="small"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            label="readonly"
            placeholder="placeholder"
            readonly
            size="small"
          ></v-select>
        </v-row>

        <v-row class="my-2">
          <v-select
            :items="['clar', 'ti', 'io', 'ivov']"
            label="readonly no placeholder"
            readonly
            size="small"
          ></v-select>
        </v-row>
      </v-col>
    </v-row>

    <v-row class="my-2">
      <v-col>
        <p>icones</p>
        <v-icon color="black">panda-ai</v-icon>
        <v-icon>panda-volume-max</v-icon>
        <v-icon color="red">panda-volume-min</v-icon>
        <v-icon color="green">panda-volume-mute</v-icon>
        <v-icon color="green">mdi-open-in-new</v-icon>
      </v-col>
    </v-row>

    <v-row class="my-2">
      <v-col>
        Alerts
        <BaseAlert
          type="success"
          title="Sucesso!"
          description="Sua operação foi concluída com sucesso."
        />

        <!-- Alerta Warning -->
        <BaseAlert
          type="warning"
          title="Atenção!"
          description="Este é um alerta de aviso."
        />

        <!-- Alerta Danger -->
        <BaseAlert type="danger" title="Erro!" description="Algo deu errado." />

        <!-- Alerta Informativo -->
        <BaseAlert
          type="informative"
          title="Informativo"
          description="Este é um alerta informativo."
        />

        <!-- Alerta Trial -->
        <BaseAlert
          type="trial"
          title="Modo Trial"
          description="Você está no modo de avaliação."
        />
        <div class="snackbar-demo my-5">
          <span class="mr-5">Clique nos botões para ver o Snackbar</span>
          <v-btn @click="showSuccessSnackbar">Show Success Snackbar</v-btn>
          <v-btn @click="showErrorSnackbar">Show Error Snackbar</v-btn>
          <v-btn @click="showWarningSnackbar">Show Warning Snackbar</v-btn>
          <v-btn @click="showInfoSnackbar">Show Info Snackbar</v-btn>
        </div>
        <div>
          Exemplo de dropzone
          <base-drop-zone
            v-if="!showPreviewImgStart"
            title="Titulo do modal de teste"
            textTitleType="Titulo da descrição de exemplo"
            textSubTitleType="SubTitulo da descrição de exemplo"
            :showCloseBtn="false"
            @close-upload="closeDialog"
            @file-uploaded="handleFileUpload"
          >
          </base-drop-zone>
        </div>
        <div>
          <h1>Regular Font Examples</h1>

          <p class="body-regular-smaller">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-smaller, 12px 150%)
          </p>
          <p class="body-regular-small">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-small, 14px 150%)
          </p>
          <p class="body-regular-base">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-base, 16px 150%)
          </p>
          <p class="body-regular-medium">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-medium, 18px 120%)
          </p>
          <p class="body-regular-large">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-large, 20px 120%)
          </p>
          <p class="body-regular-xlarge">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-xlarge, 24px 120%)
          </p>
          <p class="body-regular-larger">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-larger, 32px 120%)
          </p>
          <p class="body-regular-largest">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-largest, 40px 120%)
          </p>
          <p class="body-regular-huge">
            The quick brown fox jumps over the lazy dog (class:
            body-regular-huge, 48px 120%)
          </p>

          <h1>Bold Font Examples</h1>

          <p class="body-bold-smaller">
            The quick brown fox jumps over the lazy dog (class:
            body-bold-smaller, 12px 150%)
          </p>
          <p class="body-bold-small">
            The quick brown fox jumps over the lazy dog (class: body-bold-small,
            14px 150%)
          </p>
          <p class="body-bold-base">
            The quick brown fox jumps over the lazy dog (class: body-bold-base,
            16px 150%)
          </p>
          <p class="body-bold-medium">
            The quick brown fox jumps over the lazy dog (class:
            body-bold-medium, 18px 120%)
          </p>
          <p class="body-bold-large">
            The quick brown fox jumps over the lazy dog (class: body-bold-large,
            20px 120%)
          </p>
          <p class="body-bold-xlarge">
            The quick brown fox jumps over the lazy dog (class:
            body-bold-xlarge, 24px 120%)
          </p>
          <p class="body-bold-larger">
            The quick brown fox jumps over the lazy dog (class:
            body-bold-larger, 32px 120%)
          </p>
          <p class="body-bold-largest">
            The quick brown fox jumps over the lazy dog (class:
            body-bold-largest, 40px 120%)
          </p>
          <p class="body-bold-huge">
            The quick brown fox jumps over the lazy dog (class: body-bold-huge,
            48px 120%)
          </p>
        </div>

        <page-view>
          <template #header>
            <base-header
              has-intro
              :title="'Teste de exemplo Tabs'"
              :menu="pageMenu"
            >
              <template #actions>
                <template>
                  <span
                    >Clique no Icone ao lado para ver o componente de dica</span
                  >
                </template>
              </template>
            </base-header>
          </template>
          <template #content>
            <div style="display: grid">
              <span
                :data-intro="`<strong> Teste dica número 1 </strong><br><br>Essa é uma descrição para a dica número 1`"
                >Dica numero 1
              </span>
              <span
                :data-intro="`<strong> Teste dica número 2 </strong><br><br>Essa é uma descrição para a dica número 2`"
                >Dica numero 2
              </span>
              <span
                :data-intro="`<strong> Teste dica número 3 </strong><br><br>Essa é uma descrição para a dica número 3`"
                >Dica numero 3
              </span>
            </div>
          </template>
        </page-view>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import BaseAlert from '@/components/BaseAlert.vue'
import PageView from '@/layout/PageViewV2.vue'
import introMixin from '@/utils/intro.mixin.js'
import { mapMutations } from 'vuex'
import BaseDropZone from '../../components/BaseDropZone.vue'

export default {
  name: 'BaseComponentsTestPage',
  components: {
    BaseAlert,
    BaseHeader: () => import('@/components/BaseHeaderV2.vue'),
    PageView,
    BaseDropZone,
  },
  data() {
    return {
      checkboxMarked: false,
      checkboxMarkedDisabled: true,
      radioGroup: 1,
      hideDetails: false,
      radioActive: 'active',
      trueSwitch: true,
      textAreaText: '',
      inputText: '',
      inputPhoneNum: '',
      testTooltip: true,
      selectedItem: false,
    }
  },
  mixins: [introMixin],
  computed: {
    pageMenu() {
      const i18n = this.$i18next
      const path = 'message.pages.video.pageMenu'

      return [
        { title: i18n.t(`${path}.videos`), to: '' },
        { title: i18n.t(`${path}.trash`), to: '' },
      ]
    },
  },
  mounted() {
    this.setIntroJS({ key: 'teste', delay: 500000 })
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    testHideDetails() {
      this.hideDetails = !this.hideDetails
      console.log(this.hideDetails)
    },
    showSuccessSnackbar() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: 'Sucesso snackbar',
        type: 'success',
        buttons: [
          {
            text: 'Sucesso',
            size: 'small',
            style: 'font-size: 12px',
            type: 'neutral',
            onClick: () => {},
          },
        ],
      })
    },
    showErrorSnackbar() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: 'Erro snackbar',
        type: 'error',
        class: 'snack--error',
        removeCloseButton: false,
      })
    },
    showWarningSnackbar() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: 'Warning snackbar',
        type: 'warning',
        class: 'snack--warning',
        links: [
          {
            text: 'saiba mais',
            href: 'https://example.com/more-info',
            icon: { mdi: 'mdi-open-in-new' },
          },
        ],
      })
    },
    showInfoSnackbar() {
      this.$store.commit('user/UPDATE_GLOBAL_SNACKBAR', {
        open: true,
        text: 'Info snackbar',
        type: 'info',
        class: 'snack--info',
      })
    },
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/src/_tabsV2';
.minmaxcontainer {
  margin-top: 3px;
  display: flex;
  color: varFigma(neutral-40-light) !important;

  i {
    color: varFigma(neutral-40-light) !important;
  }

  &.disabled {
    color: varFigma(neutral-70) !important;
    i {
      color: varFigma(neutral-70) !important;
    }
  }
}
.minmax {
  text-align: right;
  /* regular/smaller */
  font-family: Rubik;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%; /* 18px */
  margin-bottom: 0 !important;
}
</style>
